import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectPackagedId, updateNewPackageTitleData } from "../../features/package/packageSlice";
import { clearPackage, addItem } from "../../features/package/packageSlice";
import { useQueryData } from "../api/useQueryData";
import { ProductPackageItems } from "../../features/package/packageInterface";
import { useGetPackageItemsQuery } from "../../features/package/packageApiSlice";
import { getRtkErrorMessage } from "../../utils/getRtkErrorMessage";

interface useInitializePackageFormProps {
    typOfAction: string;
}

export function useInitializePackageForm({ typOfAction }: useInitializePackageFormProps) {
    
    const dispatch = useDispatch();
    const selectedId = useSelector(selectPackagedId)
    const { data: packageData, isError: isErrorPackageData, error: errorPackageData, isLoading: isLoadingPackageData, refetch: refetchPackageData, isFetching: isFetchingPackageData } = useGetPackageItemsQuery(selectedId ?? undefined,  { skip: selectedId === null, refetchOnMountOrArgChange: true, })
    const errorMessagePackageData = getRtkErrorMessage(errorPackageData);
    
    useEffect(() => {
        if (typOfAction !== "updatePackage") return;
        if (!packageData) return;

        // dispatch(
        //     updateNewPackageTitleData({
        //         packageName: packageData.packageName ?? "",
        //         description: "",
        //         quantity: packageData.qty ?? 0,
        //         totalValue: packageData.totalValue ?? 0,
        //     })
        // );

        // dispatch(clearPackage());

        const validItems =
            packageData.items?.filter(
                (item: ProductPackageItems) =>
                    item.productID &&
                    item.productName &&
                    // item.categoryName &&
                    item.size &&
                    item.price
            ) ?? [];
            
        validItems.forEach((item: ProductPackageItems) => {
            dispatch(
                addItem({
                    productId: item?.productID,
                    productName: item.productName,
                    productCategory: item.categoryName,
                    productSize: item.size,
                    productPrice: item.price,
                    addons: item.addons,
                    productType: item.typeName ?? '',
                    typeOfAdd: 'old',
                    // addons: item
                })
            );
        });
    }, [typOfAction, packageData, dispatch]);

    return {
        packageData,
        isLoadingPackageData,
        isErrorPackageData,
        errorMessagePackageData
    }
}